import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { login } from "./data/API";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { setUserType } from "./data/models/GlobalAdmin";
export default function Auth({ setAccessToken }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLoginClick = () => {
    if (email === "" || password === "") {
      window.alert("please fill both fields");
      return;
    }

    setLoading(true);
    const postData = {
      email: email,
      password: password,
    };
    login(postData, (err, res) => {
      if (err) {
        setLoading(false);
   
        window.alert("Invalid Username or Password");
      } else {
        window.alert(res.message);
        console.log(res);
        setUserType(res.user_type)
        setAccessToken(res.access_token);
      }
    });
  };

  return (
    <div className="flex auth-bg  h-screen justify-center align-center ">
      <div className="flex bg-white p-5 h-58 flex-col rounded-xl shadow-xl self-center ">
        <h1 className="text-3xl font-bold mb-4" style={{ color: "#06d629" }}>
          <span style={{ color: "red" }}>SELAMAT</span> DATANG
        </h1>
        <div className="flex flex-col gap-4 px-3">
          <TextField
            color="error"
            size="small"
            label="Email"
            inputMode="email"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <TextField
            color="error"
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            size="small"
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="contained"
            sx={{ marginX: "20px" }}
            onClick={() => handleLoginClick()}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
}
